var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"factoryStock-bd tb",staticStyle:{"padding":"0"}},[_c('custom-tab',{attrs:{"list":_vm.tabList},model:{value:(_vm.formSearch.stockState),callback:function ($$v) {_vm.$set(_vm.formSearch, "stockState", $$v)},expression:"formSearch.stockState"}}),(_vm.formSearch.stockState === 2)?_c('stock-in'):_c('stock-out')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }